// Onde della laguna nella testata delle pagine elenco (.index-hero): righe
// sottili che scorrono alternando il verso. Il mouse (o il dito) agita
// l'acqua: dove passa le onde si alzano, poi l'agitazione si allarga e si
// spegne piano, come una scia. Ferme per chi riduce le animazioni, in pausa
// quando la testata non è sullo schermo.
const FORZA = .24;     // opacità delle righe più chiare
const LENTEZZA = .6;   // moltiplica la durata di un periodo: più basso, più veloce
const RIGHE = 12;
const BIN = 96;        // risoluzione orizzontale dell'agitazione

let stop = null;

export function setupHeroWaves() {
  if (stop) { stop(); stop = null; }
  const canvas = document.querySelector('.index-hero__onde');
  if (!canvas || !canvas.getContext) return;

  const hero = canvas.parentElement;
  const ctx = canvas.getContext('2d');
  const ferme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let w = 0, h = 0, telefono = false, mouse = null, last = 0, raf = null, visible = false;

  const righe = [];
  for (let r = 0; r < RIGHE; r++) {
    righe.push({
      len: 80 + (r % 4) * 24,
      amp: 2.5 + (r % 3) * 1.2,
      verso: r % 2 ? 1 : -1,
      durata: 18 + (r * 7) % 14,
      fase: Math.random() * Math.PI * 2,
      alpha: .3 + (r / RIGHE) * .7,
      agit: new Float32Array(BIN)
    });
  }

  function misura() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = hero.clientWidth;
    h = hero.clientHeight;
    telefono = w < 768;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (ferme) disegna(0, 0);
  }

  // Dal 15% dell'altezza fino al fondo, più fitte in basso
  function yRiga(r) {
    return h * (.15 + .85 * Math.pow(r / (RIGHE - 1), .8)) - 4;
  }

  function agita(x, y, forza) {
    righe.forEach((riga, r) => {
      const dy = (yRiga(r) - y) / 55;
      const vy = Math.exp(-dy * dy);
      if (vy < .02) return;
      const c = x / w * BIN;
      for (let i = Math.max(0, Math.floor(c - 8)); i < Math.min(BIN, Math.ceil(c + 8)); i++) {
        const dx = (i - c) / 3.5;
        riga.agit[i] = Math.min(3.5, riga.agit[i] + forza * vy * Math.exp(-dx * dx));
      }
    });
  }

  function disegna(sec, dt) {
    ctx.clearRect(0, 0, w, h);
    ctx.lineWidth = 1.2;
    ctx.strokeStyle = '#E9ECE7';
    if (mouse) agita(mouse.x, mouse.y, dt * 1.2); // fermo sopra: increspa piano

    righe.forEach((riga, r) => {
      // L'agitazione si spegne e si allarga ai lati
      const a = riga.agit, nuovo = new Float32Array(BIN);
      for (let i = 0; i < BIN; i++) {
        const s = (a[i - 1] || 0) + (a[i + 1] || 0);
        nuovo[i] = (a[i] * .8 + s * .1) * Math.pow(.35, dt);
      }
      riga.agit = nuovo;

      const y0 = yRiga(r);
      const k = Math.PI * 2 / riga.len;
      const spost = riga.verso * sec * riga.len / (riga.durata * LENTEZZA);
      const bob = Math.sin(sec * 1.4 / LENTEZZA + r) * 1.5;
      ctx.globalAlpha = FORZA * riga.alpha;
      ctx.beginPath();
      for (let x = 0; x <= w; x += 4) {
        const e = nuovo[Math.min(BIN - 1, Math.floor(x / w * BIN))];
        const y = y0 + bob
          + Math.sin((x - spost) * k + riga.fase) * riga.amp * (1 + e * 1.6)
          + Math.sin((x + spost * 2.3) * k * 2.7 + sec * 5) * e * 2.2; // increspatura
        if (x) ctx.lineTo(x, y); else ctx.moveTo(x, y);
      }
      ctx.stroke();
    });

    // Sfumatura verso il testo: a destra su computer, in basso sul telefono
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'destination-in';
    const g = telefono ? ctx.createLinearGradient(0, 0, 0, h) : ctx.createLinearGradient(0, 0, w, 0);
    g.addColorStop(telefono ? .3 : .1, 'rgba(0,0,0,0)');
    g.addColorStop(telefono ? .85 : .6, 'rgba(0,0,0,1)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
  }

  function frame(t) {
    const dt = last ? Math.min((t - last) / 1000, .05) : 0;
    last = t;
    disegna(t / 1000, dt);
    raf = requestAnimationFrame(frame);
  }

  function play() { if (!raf && visible && !ferme) { last = 0; raf = requestAnimationFrame(frame); } }
  function pause() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

  function muovi(e) {
    const b = hero.getBoundingClientRect();
    const x = e.clientX - b.left, y = e.clientY - b.top;
    const v = mouse ? Math.hypot(x - mouse.x, y - mouse.y) : 0;
    mouse = { x, y };
    agita(x, y, .15 + Math.min(v, 60) / 60);
  }
  function esci() { mouse = null; }

  misura();
  window.addEventListener('resize', misura);
  if (!ferme) {
    hero.addEventListener('pointermove', muovi);
    hero.addEventListener('pointerleave', esci);
  }
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) play(); else pause(); })
    : null;
  if (observer) observer.observe(hero); else { visible = true; play(); }

  stop = () => {
    pause();
    if (observer) observer.disconnect();
    window.removeEventListener('resize', misura);
    hero.removeEventListener('pointermove', muovi);
    hero.removeEventListener('pointerleave', esci);
  };
}
